module.exports = __webpack_public_path__ + "static/5-9cb14cc03558f376b9fedf702afacb4c.jpg";